import authRoutes from './auth.route.tsx';

export default [...authRoutes];
